import DropdownContentControlled from './DropdownContentControlled'

export default DropdownContentControlled
